import { Theme } from '@material-ui/core/styles/createMuiTheme';
import createStyles from '@material-ui/core/styles/createStyles';
import withStyles, { WithStyles } from '@material-ui/core/styles/withStyles';
import Typography from '@serko/zui/es/Typography';
import React, { FunctionComponent } from 'react';
import { injectIntl, InjectedIntlProps } from 'react-intl';
import compose from 'recompose/compose';
import pure from 'recompose/pure';
import messages from '../../../intl/messages';
import { AirLeg } from '../../../models/itinerary';
import { Route } from './Route';

interface OwnProps {
  arrivalCityCode: string;
  arrivalCityName: string;
  arrivalDate: Date;
  departureCityCode: string;
  departureCityName: string;
  departureDate: Date;
  stops: number;
  legs: AirLeg[];
  overnight?: string;
}

interface AirRouteProps
  extends OwnProps,
    InjectedIntlProps,
    WithStyles<typeof styles> {}

const AirRouteBase: FunctionComponent<AirRouteProps> = ({
  classes,
  intl: { formatMessage, formatTime },
  arrivalCityCode,
  arrivalCityName,
  arrivalDate,
  departureCityCode,
  departureCityName,
  departureDate,
  stops,
  legs,
  overnight,
}) => (
  <Route
    from={{
      label: formatMessage(messages.flight.startLabelText),
      mainText: formatTime(departureDate),
      secondaryText: formatMessage(messages.flight.locationText, {
        cityCode: departureCityCode,
        cityName: departureCityName,
      }),
    }}
    to={{
      label: formatMessage(messages.flight.endLabelText),
      mainText: (
        <>
          {formatTime(arrivalDate)}
          {!!overnight && (
            <Typography
              variant="caption"
              classes={{ root: classes.overnightLabel }}
            >
              {` ${overnight}`}
            </Typography>
          )}
        </>
      ),
      secondaryText: formatMessage(messages.flight.locationText, {
        cityCode: arrivalCityCode,
        cityName: arrivalCityName,
      }),
    }}
    stops={stops}
    stopCityCodes={legs.slice(1).map(({ fromCityCode }) => fromCityCode)}
    type="Air"
  />
);

// styled
const styles = ({
  zeno: {
    semantic: {
      warning: { main: color },
    },
  },
}: Theme) =>
  createStyles({
    overnightLabel: {
      color,
      display: 'inline',
      verticalAlign: 'super',
      lineHeight: 0,
    },
  });

const enhance = compose<AirRouteProps, OwnProps>(
  pure,
  withStyles(styles),
  injectIntl,
);

export const AirRoute = enhance(AirRouteBase);

AirRoute.displayName = 'AirRoute';
